import React, { createContext, useMemo, useRef } from 'react';

/**
 *
 *  @internal
 * Context which maintains the current level of dropdown menu if it is nested
 * Default is 0
 *
 */
export const NestedLevelContext = /*#__PURE__*/createContext(0);

/**
 *
 * @internal
 * Context which maintains the maximun level of dropdown menu if it is nested
 * Default is 0
 *
 */
export const TrackMaxLevelContext = /*#__PURE__*/createContext({
  maxLevelRef: {
    current: 0
  },
  setMaxLevel: () => {}
});

/**
 *
 *  @internal
 * Context provider which maintains the maximun level of dropdown menu if it is nested
 *
 */
export const TrackLevelProvider = ({
  children
}) => {
  const maxLevelRef = useRef(0);
  const value = useMemo(() => ({
    maxLevelRef,
    setMaxLevel: (level, isMin = false) => {
      maxLevelRef.current = isMin ? Math.min(maxLevelRef.current, level) : level;
    }
  }), [maxLevelRef]);
  return /*#__PURE__*/React.createElement(TrackMaxLevelContext.Provider, {
    value: value
  }, children);
};